var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1037_22833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2384 11.425V13.3375H33.3384V15.2375H35.2384V17.15H37.1384V15.2375H39.0509V13.3375H37.1384V11.425H35.2384Z",
    fill: "#FBC04E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1378 32.3875H35.2378V34.2875H37.1378V32.3875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4259 30.475H29.5259V32.3875H31.4259V34.2875H33.3384V24.7625H31.4259V30.475Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3383 5.71251H31.4258V7.62501H33.3383V5.71251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4259 22.8625H29.5259V24.7625H31.4259V22.8625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7127 5.7125V3.8125H23.8127V1.9H21.9002V0H16.1877V1.9H14.2877V3.8125H12.3752V5.7125H10.4752V20.95H8.5752V22.8625H10.4752V28.575H8.5752V30.475H12.3752V9.525H25.7127V30.475H29.5252V28.575H27.6252V22.8625H29.5252V20.95H27.6252V5.7125H25.7127Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8129 34.2875H21.9004V38.1H23.8129V34.2875Z",
    fill: "#FBC04E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7125 30.475H12.375V32.3875H25.7125V30.475Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9 22.8625H20V24.7625H21.9V22.8625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9 13.3375H20V15.2375H21.9V13.3375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0006 34.2875H18.1006V40H20.0006V34.2875Z",
    fill: "#FBC04E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0006 24.7625H18.1006V26.6625H20.0006V24.7625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0006 20.95H18.1006V22.8625H20.0006V20.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0006 15.2375H18.1006V17.15H20.0006V15.2375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0006 11.425H18.1006V13.3375H20.0006V11.425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1 22.8625H16.1875V24.7625H18.1V22.8625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1 13.3375H16.1875V15.2375H18.1V13.3375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1881 34.2875H14.2881V38.1H16.1881V34.2875Z",
    fill: "#FBC04E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5751 22.8625H6.6626V24.7625H8.5751V22.8625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6627 24.7625H4.7627V34.2875H6.6627V32.3875H8.5752V30.475H6.6627V24.7625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6627 5.71251H4.7627V7.62501H6.6627V5.71251Z",
    fill: "#FBC04E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.76328 15.2375H2.86328V17.15H4.76328V15.2375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.76328 7.62501H2.86328V9.52501H4.76328V7.62501Z",
    fill: "#FBC04E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.76328 3.8125H2.86328V5.7125H4.76328V3.8125Z",
    fill: "#FBC04E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.86318 36.1875H0.950684V38.1H2.86318V36.1875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.86318 5.71251H0.950684V7.62501H2.86318V5.71251Z",
    fill: "#FBC04E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1037_22833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.5137a1ead88d3ed59dea443129a3bc2f.svg";
export { ForwardRef as ReactComponent };